import React from "react";

//import antd components
import "antd/dist/antd.css";
import { Form, Button, Input,Spin, Dropdown,Menu, } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import logo from "../assets/images/logo-payap.png";

//import components
import { Redirect } from "react-router-dom";
import Dialog from '../shared/dialog'
import NotifyMessage from "../shared/notificationMessage"
import '../shared/css/login.css'


import { isLogin, login } from "../utils/AuthGuard";
import { isDate } from "moment";
import moment from "moment";
const Item = Menu.Item;


export default class LoginScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      isLogin: isLogin(),
      items: [],
      //RUN: เพิ่ม การ get Language 16/04/2021
      language: 'TH',

      spinner: false
    };
    //RUN: เพิ่ม การ ตรวจสอบกรณี set ค่าใหม่ (logout จะtrigger state นี้) 16/04/2021

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.dialog = new Dialog();
    this.messages = new NotifyMessage();


  }
componentWillUnmount(){
}
  handleUsernameChange(event) {
    this.setState({ username: event.target.value });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }
  componentDidMount() {
    //RUN เพิ่ม condition ใหม่ 24/04/2021
    localStorage.setItem("Language","TH")
    this.setState({language: localStorage.getItem("Language")})


  }
  onFinish(event) {
    //  event.preventDefault();
    this.spinnerControl()

    fetch(process.env.REACT_APP_API_URL + "/api/auth", {
      method: "post",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password,
      }),
    })
      .then((Response) => Response.json(), console.log('Response', JSON.stringify(Response)))
      .then((result) => {
        console.log("result: for login ", result);
        this.setState({ items: result });
        if (result.status !== undefined) {

          if (this.state.language == 'TH') {
            this.dialog.WarningDialog(result.messageTH)
          } else {
            this.dialog.WarningDialog(result.messageEN)
          }
          this.spinnerControl()

        } else {
          console.log('result hhhjjhjhjhjhjhhjjhjhjh', result)
          result.EvaluteStatus.forEach(element => {
            localStorage.setItem("selfEvalStatus", element.selfEvalStatus);
            localStorage.setItem("workLifeEvalStatus", element.workLifeEvalStatus);
            localStorage.setItem("leadershipEvalStatus", element.leadershipEvalStatus);
            localStorage.setItem("selfEvalStatusBackState",element.selfEvalStatusBackState)
            localStorage.setItem("covidInfoStatus",element.covidInfoStatus)
          });
          result.FormTypeData.forEach(ele=>{
            console.log('ele for enddate',ele)
            if(ele.FormTypeId == 1){
              //selfEval
              localStorage.setItem("selfEvalEndDate", moment(ele.EndDate));
              localStorage.setItem("selfEvalStartDate",moment(ele.StartDate) );
            }
            if(ele.FormTypeId == 2){
              //subordinate first leve
              localStorage.setItem("UnderEmpEndDate",  moment(ele.EndDate));
              localStorage.setItem("UnderEmpStartDate", moment(ele.StartDate));
              
            }
            if(ele.FormTypeId == 3){
              //leader
              localStorage.setItem("leaderEmpDate", moment(ele.EndDate));
              localStorage.setItem("leaderStartDate", moment(ele.StartDate));

            }
            if(ele.FormTypeId == 4){
              //worklife
              localStorage.setItem("workLifeEndDate", moment(ele.EndDate));
              localStorage.setItem("workLifeStartDate",moment(ele.StartDate));

            }
          })
          let date_ob = new Date();
          console.log('ree',Date.now())
          localStorage.setItem("current",Date.now())
          var datenow
          datenow = localStorage.getItem("selfEvalEndDate");
          console.log('datenow', moment(localStorage.getItem("selfEvalEndDate")).format("DD/MM/YYYY"))
          console.log('adasdasd',moment(datenow).format("DD/MM/YYYY"))
          sessionStorage.setItem("IsAuthened",true)
          localStorage.setItem("EmpId", result.EmpId);
          localStorage.setItem("TitleTH", result.TitleTH);
          localStorage.setItem("FirstNameTH", result.FirstNameTH);
          localStorage.setItem("LastNameTH", result.LastNameTH);
          localStorage.setItem("TitleEN", result.TitleEN);
          localStorage.setItem("FirstNameEN", result.FirstNameEN);
          localStorage.setItem("LastNameEN", result.LastNameEN);
          localStorage.setItem("PositionNameTH", result.PositionNameTH);
          localStorage.setItem("DepartmentTH", result.DepartmentTH);
          localStorage.setItem("DepartmentEN", result.DepartmentEN);
          localStorage.setItem("Field", result.Field);
          localStorage.setItem("GroupPositionID", result.GroupPositionID);
          localStorage.setItem("GroupPositionNAME", result.GroupPositionNameTH);
          localStorage.setItem("GroupPositionNameEN", result.GroupPositionNameEN);
          localStorage.setItem("HaveUnderEmpPrimary",result.HaveUnderEmpPrimary)
          // localStorage.setItem("EvaluteStatus", items.EvaluteStatus);
          localStorage.setItem("StartJob", result.StartJob);
          localStorage.setItem("PositionNameEN", result.PositionNameEN);
          localStorage.setItem("IsHRPrivilege", result.IsHRPrivilege);

          //Run เพิ่มการ set ค่า localstorage ให้แก่ PositionID 07/04/2021
          localStorage.setItem("PositionID", result.PositionID)
          
          login()
          this.setState((prevState) => ({
            isLogin: isLogin(),
          }));
          sessionStorage.setItem('isLogin', true)
       
          this.spinnerControl()
    
          this.messages.showSuccessMessage('Login Successful')
        }
        // localStorage.setItem("username", this.state.username);
        // localStorage.setItem("password", this.state.password);
      });

  }

  //RUN: เพิ่ม changeLangFunction เพื่อทำการ setstate ให้ language 16/04/2021

  changeLangFunction(item) {
    localStorage.setItem("Language", item);
    this.setState({ language: item })
  }
  spinnerControl() {
    this.setState({ spinner: !this.state.spinner })
  }
  
  render() {
    const { isLogin } = this.state;
    const overlay = () => (
      <Menu>
        <Item onClick={()=>this.changeLangFunction('TH')}>
          TH - ภาษาไทย
        </Item>
        <Item onClick={()=>this.changeLangFunction('EN')}>
          EN - English
        </Item>
      </Menu>
    );
    
    console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    // if(localStorage.length==0){
    //   localStorage.clear()
    //   localStorage.setItem("Language", "TH")
    // }else{
    //   if(localStorage.length>1){
    //     return <Redirect to="/home" />
    //   }

    // }
    //add data to local storage

    return isLogin ? <Redirect to="/home" /> :
      <Spin tip="Loading..." spinning={this.state.spinner}>

        {/* // RUNเพิ่มการ ส่ง props ให้ทำการ callback function และ re-render 
  component เมื่อทำการเปลี่ยนภาษา 16/04/2021 */}

        {/* <HeaderComponent data={{
          language: this.state.language,
          changeLang: this.changeLangFunction.bind(this)
        }} ></HeaderComponent> */}
        {/* RUN: เพิ่มการ ตรวจสอบ TH/EN 16/04/2021*/}
        <div class="LoginMar_t120">
          <div class="center-login">
            <div style={{ 
              padding: 10,
              background:'#94d1ff' ,
              borderRadius:'5px'
            }}>
              <div style={{ marginTop: 15 }}>
                <img src={logo} alt="Logo" />
                <p style={{color: "#fff", fontSize: 16, marginTop: 15 }}>
                สำนักทรัพยากรบุคคล <br /> Office of Human Resources
                </p>
              </div>
    
           
  
            </div>
            <div class="box-login">
              {/* <div style={{ marginTop: 35, textAlign: "center" }}> */}
              {this.state.language == 'TH' ?
                <p>
                  ยินดีต้อนรับ! <br /> กรุณากรอกชื่อผู้ใช้งาน (Username) และ รหัสผ่าน
            (Password)
          </p>
                : <p>
                  Welcome! <br /> Please enter account informations Username and Password
        </p>
              }

              {/* start login form */}
              <Form
                name="basic"
                onFinish={this.onFinish}
                style={{ maxWidth: "60%", margin: "auto", marginTop: 15, }}
              >
                {/* RUN: เพิ่มการ ตรวจสอบ TH/EN 16/04/2021*/}

                {this.state.language == 'TH' ?
                  <Form.Item 
                    name="username"
                    rules={[{ required: true, message: "กรุณากรอกชื่อผู้ใช้งาน" }]}
                  >
                    <Input input
                      placeholder="ชื่อผู้ใช้งาน"
                      prefix={<UserOutlined />}
                      value={this.state.username}
                      onChange={this.handleUsernameChange}
                    />
                  </Form.Item>
                  :
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: "Please enter username" }]}
                  >
                    <Input
                      placeholder="Username"
                      prefix={<UserOutlined />}
                      value={this.state.username}
                      onChange={this.handleUsernameChange}
                    />
                  </Form.Item>
                }
                {/* RUN: เพิ่มการ ตรวจสอบ TH/EN 16/04/2021*/}
                {this.state.language == 'TH' ?
                  <Form.Item 
                    name="password"
                    rules={[{ required: true, message: "กรุณากรอกรหัสผ่าน" }]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="รหัสผ่าน"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                      prefix={<LockOutlined />}
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                    />
                  </Form.Item>
                  :
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: "Please enter password" }]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                      prefix={<LockOutlined />}
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                    />
                  </Form.Item>
                }
            
                <Form.Item>
                  <Dropdown overlay={overlay()} trigger={["click"]} >
                      <Button placeholder="ภาษา-Language">
                        {this.state.language == 'TH' ?
                        "TH - ภาษาไทย":
                        "EN - English"
                        }
                      </Button>
                  </Dropdown>
                </Form.Item>
                {/* RUN: เพิ่มการ ตรวจสอบ TH/EN 16/04/2021*/}
                {this.state.language == 'TH' ?
                  <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit">
                      เข้าสู่ระบบ
              </Button>
                  </Form.Item>
                  :
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Sign In
            </Button>
                  </Form.Item>
                }
              </Form>
              {/* end login form */}
              {/* RUN: เพิ่มการ ตรวจสอบ TH/EN 16/04/2021*/}

              {this.state.language == 'TH' ?
                <div className="body-container">
                  <p style={{ marginTop: 25 }}>
                    ชื่อผู้ใช้งาน (Username) และ รหัสผ่าน (Password) ให้ใช้รหัสเดียวกับชื่อผู้ใช้งาน (Username) และ รหัสผ่าน (Password)เพื่อเข้าใช้งานระบบอินเทอร์เน็ต (Internet) มหาวิทยาลัยพายัพ
            </p>
                  <p style={{ color: "red" }}>
                    กรณีมีข้อสงสัยเกี่ยวกับระบบการประเมินฯ โปรดสอบถาม
              สำนักทรัพยากรบุคคล <br />
              โทร 311, 312, 313
            </p>

            <b> หากพบปัญหาการใช้งาน สามารถแจ้งปัญหาได้ <a href="https://forms.office.com/r/7gLDS635Hz"> คลิกที่นี่ </a></b>
            </div>
            :
            <div className="body-container">
              <p style={{ marginTop: 25 }}>
                Username and Password use the same Username and Password of Payap University's Internet
            </p>
                  <p style={{ color: "red" }}>
                    If you have any question regarding the system,please feel free to contact<br />
               the Office of Human Resources at telephone number (6653) 851478  <br />
              ext. 311, 312, 313
            </p>
                </div>

              }

            <b> To Reporting issues <a href="https://forms.office.com/r/7gLDS635Hz"> Click Here </a></b>
            </div>
          </div>
        </div>
        {/* </div> */}
      </Spin>

  }


}